import {
  adjustmentIcon,
  depositIcon,
  dollarIcon,
  giftIcon,
  giftIcon2,
  interestIcon,
  withdrawIcon,
} from "@assets";
import { TransactionType } from "@ctypes";

export const icons: Record<TransactionType, string> = {
  [TransactionType.Contribution]: depositIcon,
  [TransactionType.Adjustment]: adjustmentIcon,
  [TransactionType.Debit]: depositIcon,
  [TransactionType.Credit]: depositIcon,
  [TransactionType.Withdrawal]: withdrawIcon,
  [TransactionType.WithdrawalAll]: withdrawIcon,
  [TransactionType.Journal]: withdrawIcon,
  [TransactionType.Reversal]: adjustmentIcon,
  [TransactionType.Transfer]: depositIcon,
  [TransactionType.Dividend]: giftIcon,
  [TransactionType.Fee]: adjustmentIcon,
  [TransactionType.Interest]: interestIcon,
  [TransactionType.Tax]: adjustmentIcon,
  [TransactionType.OneTimeContribution]: depositIcon,
  [TransactionType.RecurringContribution]: depositIcon,
  [TransactionType.Reward]: giftIcon,
  [TransactionType.Gifting]: giftIcon2,
  [TransactionType.SubscriptionFee]: dollarIcon,
};
